import React, { Component } from "react";
import * as Cookies from "es-cookie";
import { Container, Row, Col, } from "react-bootstrap";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";


import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../../preloader/PreloaderTwo";
import { Line, Pie } from "react-chartjs-2";
import moment from 'moment';
import { components } from "react-select";
import SelectDropDown from "../../../selectdropdown/SelectDropDown";
import CardLessDataTableWithOutSearch from "../../../datatables/CardLessDataTableWithOutSearch";

const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <i className="fal fa-angle-down" />
            </components.DropdownIndicator>
        )
    );
};


var options = {
    legend: {
        display: true,
        position: "bottom",
        labels: {
            boxWidth: 10
        }
    },
    scales: {
        xAxes: [
            {
                ticks: { display: false }
            }
        ],

    },
    layout: {
        padding: {
            left: 20,
            right: 20,
            top: 10,
            bottom: 10,
        },
    },
    hover: {
        cursor: 'pointer', // Change cursor style to 'pointer'
    },

};



const selectionTimelines = [{ value: 1, label: "Last 30 Days" }, { value: 2, label: "Last 60 Days" }, { value: 3, label: "3 Months" }, { value: 4, label: "Overall" }]

const GET_OFFLIE_RESULTS = gql`
 query($student_mobile: String,$timeline:Int) {
    getStudentExamResults(student_mobile: $student_mobile,timeline:$timeline) {
        year
        month
        date
        overall_total_rank
        overall_gained_rank
        overall_gained_marks
        overall_total_marks
        overall_avg
        exam_date
        paper_name
        student_marks{
          subject_id
          subject_wise_total_marks
          subject_wise_gained_rank
          subject_wise_gained_marks
          subject_wise_total_rank
          subject_wise_avg
        }
        }
    }
`;




class NAOfflineMarksDetails extends Component {



    articlecolumFunc() {
        const articlecolumns = [
            {
                dataField: "exam_date",
                text: "Date",
                sort: true,
            },
            {
                dataField: "exam_name",
                text: "Exam Name",
                sort: true,
            },
            {
                dataField: "overall",
                text: "Overall",
                formatter: this.actionsFormatterOverall,
            },

        ]
        let  examWiseSubjects = []
        if (this.props.globals.offlineExamSubjects.length > 0) {
            this.props.globals.exams.filter((item) => item.id == +this.props.stateData.studentData.exam_id)[0].exam_subjects.map((item1) => {
                this.props.globals.offlineExamSubjects.map((item2) => {
                    if (item1.subject_id == item2.id) {
                        const newObj = {
                            value: item2.id,
                            label: item2.subject
                        }
                        examWiseSubjects.push(newObj);
                    }
                })
            })

            examWiseSubjects.map((item) => {
                articlecolumns.push({
                    dataField: item.label.replace(" ", "_"),
                    text: item.label,
                    sort: true,
                    formatter: this.actionsFormatterSubject(item.value, item.label),
                  })
              })
        }
        console.log("examWiseSubjects", examWiseSubjects);  
        return articlecolumns
    }

    // articlecolumns = [
    //     {
    //         dataField: "exam_date",
    //         text: "Date",
    //         sort: true,
    //     },
    //     {
    //         dataField: "exam_name",
    //         text: "Exam Name",
    //         sort: true,
    //     },
    //     {
    //         dataField: "overall",
    //         text: "Overall",
    //         formatter: this.actionsFormatterOverall,
    //     },
    //     {
    //         dataField: "botanyData",
    //         text: "Botany",
    //         formatter: this.actionsFormatterBotany,
    //     },
    //     {
    //         dataField: "physicsData",
    //         text: "Physics",
    //         formatter: this.actionsFormatterPhysics,
    //     },
    //     {
    //         dataField: "chemistryData",
    //         text: "Chemistry",
    //         formatter: this.actionsFormatterChemistry,
    //     },
    //     {
    //         dataField: "ZoologyData",
    //         text: "Zoology",
    //         formatter: this.actionsFormatterZoology,
    //     },
    // ];


    actionsFormatterOverall(cell, row,) {
        return (
            <>
                <p>M: {row.gainedMarks} / {row.totalMarks}</p>
                <p>R: {row.gainedRank} / {row.totalRank}</p>
            </>
        )
    }

    actionsFormatterSubject(subjectId, subjectLabel) {
        return (cell, row) => {
            const subjectFilterData = row.individualMarks.find((item) => item.subject_id === subjectId);
            if (subjectFilterData) {
                return (
                    <>
                        <p>M: {subjectFilterData.subject_wise_gained_marks} / {subjectFilterData.subject_wise_total_marks}</p>
                        <p>R: {subjectFilterData.subject_wise_gained_rank} / {subjectFilterData.subject_wise_total_rank}</p>
                    </>
                );
            } else {
                return (
                    <>
                        <p>M: -</p>
                        <p>R: -</p>
                    </>
                );
            }
        };
    }

    // actionsFormatterBotany(cell, row,) {
    //     let subjectFilterData = row.individualMarks.find((item) => item.subject_id == 1);
    //     if (subjectFilterData != null) {
    //         return (
    //             <>
    //                 <p>M: {subjectFilterData.subject_wise_gained_marks} / {subjectFilterData.subject_wise_total_marks}</p>
    //                 <p>R: {subjectFilterData.subject_wise_gained_rank} / {subjectFilterData.subject_wise_total_rank}</p>
    //             </>
    //         )
    //     } else {
    //         return (
    //             <>
    //                 <p>M: -</p>
    //                 <p>R: -</p>
    //             </>
    //         )
    //     }
    // }

    // actionsFormatterPhysics(cell, row,) {
    //     let subjectFilterData = row.individualMarks.find((item) => item.subject_id == 2);
    //     if (subjectFilterData != null) {
    //         return (
    //             <>
    //                 <p>M: {subjectFilterData.subject_wise_gained_marks} / {subjectFilterData.subject_wise_total_marks}</p>
    //                 <p>R: {subjectFilterData.subject_wise_gained_rank} / {subjectFilterData.subject_wise_total_rank}</p>
    //             </>
    //         )
    //     } else {
    //         return (
    //             <>
    //                 <p>M: -</p>
    //                 <p>R: -</p>
    //             </>
    //         )
    //     }
    // }

    // actionsFormatterChemistry(cell, row,) {
    //     let subjectFilterData = row.individualMarks.find((item) => item.subject_id == 3);
    //     if (subjectFilterData != null) {
    //         return (
    //             <>
    //                 <p>M: {subjectFilterData.subject_wise_gained_marks} / {subjectFilterData.subject_wise_total_marks}</p>
    //                 <p>R: {subjectFilterData.subject_wise_gained_rank} / {subjectFilterData.subject_wise_total_rank}</p>
    //             </>
    //         )
    //     } else {
    //         return (
    //             <>
    //                 <p>M: -</p>
    //                 <p>R: -</p>
    //             </>
    //         )
    //     }
    // }

    // actionsFormatterZoology(cell, row,) {
    //     let subjectFilterData = row.individualMarks.find((item) => item.subject_id == 5);
    //     if (subjectFilterData != null) {
    //         return (
    //             <>
    //                 <p>M: {subjectFilterData.subject_wise_gained_marks} / {subjectFilterData.subject_wise_total_marks}</p>
    //                 <p>R: {subjectFilterData.subject_wise_gained_rank} / {subjectFilterData.subject_wise_total_rank}</p>
    //             </>
    //         )
    //     } else {
    //         return (
    //             <>
    //                 <p>M: -</p>
    //                 <p>R: -</p>
    //             </>
    //         )
    //     }
    // }


    render() {
        console.log("prrrrropopopop", this.props);
        const offlineResults = this.props.offlineResults;
        const loading = offlineResults.loading;
        const error = offlineResults.error;


        if (loading) return <PreloaderTwo />;

        if (error !== undefined) {
            alert("Server Error. " + error.message);
            return null;
        }


        console.log("hellllo", offlineResults.getStudentExamResults);

        let  examWiseSubjects = []
        if (this.props.globals.offlineExamSubjects.length > 0) {
            this.props.globals.exams.filter((item) => item.id == +this.props.stateData.studentData.exam_id)[0].exam_subjects.map((item1) => {
                this.props.globals.offlineExamSubjects.map((item2) => {
                    if (item1.subject_id == item2.id) {
                        const newObj = {
                            value: item2.id,
                            label: item2.subject
                        }
                        examWiseSubjects.push(newObj);
                    }
                })
            })
        }

        let labels = [];
        let overAllAvg = [];

         let subjectsAvgs = {}

        let marksDetails = [];

        if (offlineResults.getStudentExamResults.length > 0) {
            console.log("getStudentExamResults", offlineResults.getStudentExamResults);

            let orderWiseResults = offlineResults.getStudentExamResults.sort((a, b) => a.exam_date - b.exam_date);
            orderWiseResults.map((item) => {
                let date = moment.unix(item.exam_date).format("DD-MM-YYYY");

                let examWiseSubjectAvg = []
                examWiseSubjects.forEach(subject => {
                    examWiseSubjectAvg[subject.value] = 0;
                
                    item.student_marks.forEach(item1 => {
                        if (item1.subject_id === subject.value) {
                            examWiseSubjectAvg[subject.value] = item1.subject_wise_avg;
                        }
                    });
                });
                overAllAvg.push(item.overall_avg);
                labels.push(date);
                subjectsAvgs = examWiseSubjectAvg
                
            });

            let tableOrderWiseResults = offlineResults.getStudentExamResults.sort((a, b) => b.exam_date - a.exam_date);

            tableOrderWiseResults.map((item) => {
                const newObj = {
                    exam_date: moment.unix(item.exam_date).format("DD-MM-YYYY"),
                    exam_name : item.paper_name,
                    totalMarks: item.overall_total_marks,
                    gainedMarks: item.overall_gained_marks,
                    totalRank: item.overall_total_rank,
                    gainedRank: item.overall_gained_rank,
                    individualMarks: item.student_marks
                }
                marksDetails.push(newObj);
            })

        }

        // const data = {
        //     labels: labels,
        //     datasets: [

        //         {
        //             label: "Over All",
        //             fill: false,
        //             borderColor: "blue",
        //             borderWidth: 2,
        //             pointRadius: 2,
        //             data: overAllAvg
        //         },
        //         {
        //             label: "Botany",
        //             fill: false,
        //             borderColor: "rgb(0, 143, 251)",
        //             borderWidth: 1,
        //             pointRadius: 2,
        //             data: botanyAvg
        //         },
        //         {
        //             label: "Physics",
        //             fill: false,
        //             borderColor: "rgb(0, 227, 150)",
        //             borderWidth: 1,
        //             pointRadius: 2,
        //             data: physicsAvg
        //         },
        //         {
        //             label: "Chemistry",
        //             fill: false,
        //             borderColor: "rgb(254, 176, 25)",
        //             borderWidth: 1,
        //             pointRadius: 2,
        //             data: chemistryAvg
        //         },
        //         {
        //             label: "Zoology",
        //             fill: false,
        //             borderColor: "rgb(255, 69, 96)",
        //             borderWidth: 1,
        //             pointRadius: 2,
        //             data: zoologyAvg
        //         },

        //     ]
        // };

        let datasets = [
            {
                label: "Over All",
                fill: false,
                borderColor: "blue",
                borderWidth: 2,
                pointRadius: 2,
                data: overAllAvg
            }
        ];
        
        examWiseSubjects.forEach(subject => {
            const subjectData = {
                label: subject.label,
                fill: false,
                borderColor: `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`,
                borderWidth: 1,
                pointRadius: 2,
                data: []
            };
            let graphDetails = offlineResults.getStudentExamResults.sort((a, b) => a.exam_date - b.exam_date)
            graphDetails.map(detail => {
                const subjectDetail = detail.student_marks.find(mark => mark.subject_id === subject.value);
                if (subjectDetail) {
                    subjectData.data.push(subjectDetail.subject_wise_avg);
                } else {
                    subjectData.data.push(null); 
                }
            });
        
            datasets.push(subjectData);
        });
        
        const data = {
            labels: labels,
            datasets: datasets
        };
            

        return (

            <div className="offlineMarks mt-3" >
                <div className="bg-white border-0 d-flex justify-content-around align-items-center mt-3">
                    <h6 className="mb-0">Offline Marks Report</h6>
                    <div className="weekselection">
                        <SelectDropDown
                            options={selectionTimelines}
                            handleChange={this.props.handleSelectTimelineChange}
                            dropdownIndicator={{ DropdownIndicator }}
                            stateData={this.props.stateData.marksSelectionTypeObj}
                        />
                    </div>
                </div>
                <div style={{ overflow: 'auto', width: '100%', marginRight: "50px" }} className="chart-container">
                    <Line
                        data={data}
                        options={options}
                        height={60}
                    />
                </div>
                <Row className="mt-3">
                    <Col sm={12}>
                        <CardLessDataTableWithOutSearch
                            parentData={marksDetails}
                            particlecolumns={this.articlecolumFunc()}
                        />
                    </Col>
                </Row>
            </div>

        );
    }
}

export default withRouter(
    compose(
        graphql(
            GET_OFFLIE_RESULTS,
            {
                options: props => ({
                    variables: {
                        student_mobile: props.stateData.studentData.contact_no.toString(),
                        timeline: parseInt(props.stateData.marksSelectionType)
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "offlineResults"
            }
        ),
    )(NAOfflineMarksDetails)
);   
